jQuery(document).ready(function () {
    $(document).on('click', '.dnHubspotChatTrigger', function (e) {
        e.preventDefault();
        var hubspotMessanger = $('#hubspot-messages-iframe-container');
        if (hubspotMessanger.length) {
            hubspotMessanger.addClass('isVisable');
            window.HubSpotConversations.widget.open();
        }
    });
});